
        var docEl = document.documentElement;
        var clientWidth = docEl.clientWidth;
        if (clientWidth) {
            docEl.style.fontSize = clientWidth >= 600 ? '100px' : 100 * (clientWidth / 414) + 'px';
        }
    